export default "const { getStoreInformation } = require('./store-information');\n\nmodule.exports = {\n  getStoreInformation\n};\n";